import { useMemo } from 'react';

import type { SingleValue } from 'react-select';

import { Select } from '@/_components/form-components/select';

import { allStates } from './states';

export function FiltersStateSelector({
  // country,
  value,
  onChange,
}: {
  country: string;
  value: SingleValue<{
    id: number;
    name: string;
    country_id: number;
    abbreviation: string;
  }>;
  onChange: (
    value: {
      id: number;
      name: string;
      country_id: number;
      abbreviation: string;
    } | null
  ) => void;
}) {
  // const options = staticStates.find((c) => c.country.toLowerCase() === country.toLowerCase())?.states;
  const getOptionLabel = (option: { name: string; value: string }) => option.name;

  const handleChange = (newValue: SingleValue<{ name: string; value: string }>) => {
    onChange({
      id: -1,
      name: newValue?.name ?? '',
      country_id: -1,
      abbreviation: '',
    });
  };

  const calcValue = useMemo(() => {
    if (!value) return null;
    return {
      value: value.name,
      name: value.name,
    };
  }, [value]);

  return (
    <Select
      menuListClassName="max-h-28!"
      options={allStates}
      getOptionLabel={getOptionLabel}
      value={calcValue}
      onChange={handleChange}
      showSearchIcon
      menuPortalTarget={null}
    />
  );
}
